import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiCustomerSettingsPreviewDialogComponent } from './customer-settings-preview-dialog/customer-settings-preview-dialog.component';
import { AppTextService } from '@fi-shared/app-text';
import { FiCustomerSettingsService } from './customer-settings.service';
import { ISiteDesign } from '@fi-shared/models';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { FiUploadType } from '@fi-shared/types/upload-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiImageSize } from '@fi-shared/types';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';

enum RecommendedSizes {
    Logo = '150x150',
    Landscape = '1920x1200',
    Portrait = '1200x1920',
}

@Component({
    selector: 'fi-customer-settings',
    templateUrl: './customer-settings.component.html',
    styleUrls: ['./customer-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-settings' },
    standalone: false,
})
export class FiCustomerSettingsComponent implements OnInit {
    @Input() customerSettings: ISiteDesign;

    FiUploadType = FiUploadType;
    FiImageSize = FiImageSize;
    RecommendedSizes = RecommendedSizes;
    editTabs: EditTabsModel;

    constructor(
        private loadingService: LoadingService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private customerSettingsService: FiCustomerSettingsService,
        private sessionService: SessionService,
        private stateService: FiStateService,
        private saveChangesWarningService: SaveChangesWarningService,
        private cdRef: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.editTabs = new EditTabsModel(
            this.appTextService.get('appearance.customer_settings_header'),
            undefined,
            this.appTextService.get('customer_settings.preview_changes'),
        );
        const getModelData = () => {
            return {
                customerSettings: this.customerSettings,
            };
        };
        this.saveChangesWarningService.start(getModelData);
        this.cdRef.detectChanges();
    }

    previewChanges() {
        this.fiDialogsService
            .custom({
                yesButtonText: this.appTextService.get('common.save_changes'),
                noButtonText: this.appTextService.get('common.back_to_edit'),
                hideHeader: true,
                contentComponentRef: FiCustomerSettingsPreviewDialogComponent,
                contentComponentData: this.customerSettings,
                config: {
                    minWidth: '300px',
                    maxWidth: '95%',
                    maxHeight: 'unset',
                    panelClass: 'fi-customer-settings-preview-panel',
                },
            })
            .onYesButtonClick(() => {
                this.loadingService
                    .trackPromise(this.customerSettingsService.saveCustomerSettings(this.customerSettings))
                    .then(() => {
                        this.saveChangesWarningService.stop();
                        if (this.customerSettings.BrandingColor) {
                            this.sessionService.setSiteDesign(this.customerSettings);
                        }
                        this.stateService.go(FiStateNames.Appearance.View);
                    });
            });
    }
}
